module.exports = __webpack_public_path__ + "static/media/arrow-bottom-dark.aa6b4a4a.png";